
/**
Todo: Submit Handler bei dateSelect raus (ist in den Templates meistens)

Modes:

    Ohne:
        - from = null, to = null
        - Keine Auswahl im Kalender anzeigen
        - Bei Auswahl im Kalender auf "Exakt" springen

    Range:
        - Klassischer Datepicker mit Auswahl

    Flexibel:
        - Auswahl der Nächte in einem Zeitraum, der Datepicker ignoriert dann die maximalen buchbaren Tage bei der Auswahl
*/

var $ = require('jquery');
var Backbone = require('backbone');

var DateTime = require('DateTime');
var TemplateCache = require('TemplateCache');
var Registry = require('registry');

var DatepickerControlsView = Backbone.View.extend({
    /* model = ReservaDatePicker */

    events: {
        'click .modes span': 'handleChangeMode',
        'change select[name="control-nights"]': 'handleChangeNights',
        'change input[name="control-from"]': 'handleChangeFrom',
        'change input[name="control-to"]': 'handleChangeTo',
        'focus input[name="control-from"]': 'handleFocus',
        'focus input[name="control-to"]': 'handleFocus',
        'keydown input[name="control-from"]': 'preventSubmitFrom',
        'keydown input[name="control-to"]': 'preventSubmitTo',
        'click .datepicker-close': 'closeDatepicker',
    },

    constructor: function(options) {
        this.datepicker = options.datepicker;
        Backbone.View.apply(this, arguments);
    },

    initialize: function() {
        this.listenTo(this.model, "change:select_mode change:nights change:from change:to", this.render);
        this.nextFocus = null;
    },

    render: function() {
        var data = this.model.toJSON();

        /* Bei nativen HTML Datepickern brauchen wir wieder das US-Format ... */
        var format = this.model.get("isTouchDevice") ? "YYYY-MM-DD" : "L";

        data.from_human = data.from ? DateTime.parse(data.from).format(format) : "";
        data.to_human = data.to ? DateTime.parse(data.to).format(format) : "";

        this.$el.html(TemplateCache.render("datepicker-controls", data));

        if ( this.nextFocus ) {
            this.$el.find(this.nextFocus).focus();
        }
    },

    /*
     DOM handlers
    */
    handleChangeMode: function(e) {
        e.preventDefault();
        var target = $(e.currentTarget);
        var new_mode = target.data('mode');
        console.log("new_mode", new_mode);
        this.model.set("select_mode", new_mode);
    },

    handleChangeNights: function(e) {
        var new_nights = e.currentTarget.value;
        var diff = new_nights - this.model.get("nights");
        var to = DateTime.parse(this.model.get("to"));

        if ( !to ) to = DateTime.parse(this.model.get("from"));
        if ( !to ) return;

        if ( this.model.get("select_mode") === "flex" ) {
            this.model.set("nights", new_nights);
            return;
        }

        if ( diff > 0 ) {
            to.add(diff, 'days');
        } else {
            to.subtract(diff * -1, 'days');
        }

        /* "nights" wird vom DatePicker neu berechnet und gesetzt */
        this.datepicker.setTo(to._d);
        this.datepicker.datepicker.datepicker("refresh");
    },

    handleChangeFrom: function(e) {
        if ( this.model.get("select_mode") === "flex" ) return;

        var now = DateTime.resetTimeFields(DateTime.moment());
        var new_from = DateTime.parse(e.currentTarget.value, true);
        var new_to = null;

        if ( new_from.isValid() ) {
            if ( new_from.isBefore(now) ) {
                new_from = now;
            }

            this.nextFocus = "input[name=control-to]";

            var new_to = new_from.clone();
            new_to.add(this.model.get("nights"), "days");

            if ( +(new_from._d) === +(new_to._d) ) {
                new_to.add(1, "days");
            }

            this.datepicker.setFrom(new_from._d);
            this.datepicker.setTo(new_to._d);
            this.datepicker.datepicker.datepicker("refresh");

            this.nextFocus = null;
        } else {
            this.nextFocus = "input[name=control-from]";
            this.render();
        }
    },

    handleChangeTo: function(e) {
        if ( this.model.get("select_mode") === "flex" ) return;

        var now = DateTime.resetTimeFields(DateTime.moment());
        var new_to = DateTime.parse(e.currentTarget.value, true);
        var current_from = DateTime.parse(this.model.get("from"), true);

        if ( new_to && new_to.isValid() && current_from && current_from.isValid() ) {
            this.nextFocus = "input[name=control-from]";

            if ( +(current_from._d) === +(new_to._d) ) {
                new_to.add(1, "days");
            }

            if ( new_to.isBefore(now) ) {
                /* Are you kidding me? */
                new_to = now.clone();
                new_to.add(this.model.get("nights"), "days");

                this.datepicker.setFrom(now._d);
                this.datepicker.setTo(new_to._d);
            }

            else if ( new_to.isBefore(current_from) ) {
                /* Users are insane */
                this.datepicker.setFrom(new_to._d);
                this.datepicker.setTo(current_from._d);
            } else {
                this.datepicker.setTo(new_to._d);
            }

            this.datepicker.datepicker.datepicker("refresh");
            this.nextFocus = null;
        } else {
            this.nextFocus = "input[name=control-to]";
            this.render();
        }
    },

    handleFocus: function(e) {
        this.datepicker.handleControlInputFocus();
    },

    preventSubmitFrom: function(e) {
        if ( e.keyCode == 13 ) {
            e.preventDefault();
            this.$el.find('input[name=control-to]').focus();
        }
    },

    preventSubmitTo: function(e) {
        if ( e.keyCode == 13 ) {
            e.preventDefault();
            this.$el.find('input[name=control-to]').blur();
            setTimeout(() => {
                this.datepicker.app.trigger("DatePicker.dateSelected", this.datepicker);    
            }, 0);
        }
    },

    closeDatepicker: function() {
        this.datepicker.app.hideDatepicker();
    },

});

module.exports = DatepickerControlsView;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/engine/views/DatepickerControlsView.js
 **/